import React from 'react';
import { Box } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { PAGE_ACCENTS, PageAccentName } from '../../theme/pageAccents';

interface PageIconTileProps {
  icon: React.ReactNode;
  accent?: PageAccentName;
  size?: number;
  iconSize?: number;
  onDarkSurface?: boolean;
  mb?: number;
  sx?: SxProps<Theme>;
}

/** Flat accent tile shared by page headers, navigation, and page cards. */
const PageIconTile: React.FC<PageIconTileProps> = ({
  icon,
  accent,
  size = 48,
  iconSize = Math.round(size * 0.54),
  onDarkSurface = false,
  mb,
  sx,
}) => (
  <Box
    aria-hidden="true"
    sx={{
      width: size,
      height: size,
      mb,
      borderRadius: size <= 40 ? 1.25 : 1.5,
      display: 'grid',
      placeItems: 'center',
      flexShrink: 0,
      bgcolor: theme => accent
        ? PAGE_ACCENTS[accent][onDarkSurface ? 'dark' : theme.palette.mode]
        : theme.palette.primary.main,
      color: theme => onDarkSurface
        ? '#18352A'
        : theme.palette.mode === 'dark' ? theme.palette.background.default : theme.palette.common.white,
      '& svg': { fontSize: iconSize },
      ...sx,
    }}
  >
    {icon}
  </Box>
);

export default PageIconTile;
